import { createAction } from "@reduxjs/toolkit";
import { BeforeInstallPromptEvent } from "../../models/beforeinstallevent";

export const enum AndroidDownloadActions {
  SET_EVENT_DOWNLOAD,
}

export const setEventDownload =
  createAction<BeforeInstallPromptEvent>("SET_EVENT_DOWNLOAD");
